import { useEffect, useRef } from "react";
import { setTrackingPage, track } from "./tracker";

const STEP_NAMES = {
  1: "Choose your Package",
  2: "Schedule",
  3: "Tell us about your Event",
  4: "Review",
  5: "Secure Payment",
};

export default function useBookingStepTracking(step, artistId, startedAt) {
  const previousStep = useRef(null);
  const enteredAt = useRef(Date.now());

  useEffect(() => {
    if (step < 1 || step > 5) return;
    const stepName = STEP_NAMES[step] || `Step ${step}`;
    const previous = previousStep.current;
    if (previous && previous !== step) {
      if (step > previous) {
        track("booking_step_completed", {
          step_number: previous,
          step_name: STEP_NAMES[previous] || `Step ${previous}`,
          time_spent_ms: Date.now() - enteredAt.current,
          artist_id: artistId,
        });
      } else {
        track("booking_step_back", {
          from_step: previous,
          to_step: step,
          artist_id: artistId,
        });
      }
    }
    previousStep.current = step;
    enteredAt.current = Date.now();
    setTrackingPage({
      path: window.location.pathname,
      lastStep: step,
      artistId,
      bookingStartedAt: startedAt,
    });
    track("booking_step_viewed", {
      step_number: step,
      step_name: stepName,
      artist_id: artistId,
    });
  }, [step, artistId, startedAt]);
}

export { STEP_NAMES };
